'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = undefined;

var _Divider2 = require('./Divider');

var _Divider3 = _interopRequireDefault(_Divider2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Divider3.default;
exports.Divider = _Divider3.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Dividers/index.js
// module id = 265
// module chunks = 42657473041956 79611799117203 201563372448855 213534597649335